import React, { createContext, useContext, useState } from 'react';
import { syncLogic } from '../../Hooks/useSyncLogic'; // Import syncLogic instead of useSyncLogic

const SyncContext = createContext();

export const SyncProvider = ({ children, navigate }) => {
  // Define state for isLoading and isInitialized
  const [isLoading, setIsLoading] = useState(false);
  const [isInitialized, setIsInitialized] = useState(false);

  // Call syncLogic with required arguments
  const sync = syncLogic(setIsLoading, setIsInitialized, navigate);

  return (
    <SyncContext.Provider value={sync}>
      {children}
    </SyncContext.Provider>
  );
};

export const useSync = () => {
  const context = useContext(SyncContext);
  if (!context) {
    throw new Error('useSync must be used within a SyncProvider');
  }
  return context;
};